import { Box, Typography, IconButton, CircularProgress } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloseIcon from "@mui/icons-material/Close";
import { DefaultLayoutZIndex } from "../../_utils/constraints";

const Overlay = ({
  isVisible,
  content,
  onClose,
  backgroundColor = "rgba(128, 128, 128, 0.5)",
}) => {
  const theme = useTheme();
  const errorColor = theme.palette.error.main;

  return (
    isVisible && (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          zIndex: DefaultLayoutZIndex + 800,
        }}
      >
        {content}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            color: "white",
            backgroundColor: errorColor,
            "&:hover": { backgroundColor: alpha(errorColor, 0.7) },
          }}
        >
          <CloseIcon color="white" />
        </IconButton>
      </Box>
    )
  );
};

const WrapperProvider = ({ stateUpdate, setLoading, setError, children }) => {
  const loadingContent = <CircularProgress />;
  const errorContent = (
    <>
      <ErrorOutlineIcon sx={{ fontSize: 60, color: "error.main", mb: 2 }} />
      <Typography
        variant="h6"
        sx={{ color: "error.main", textAlign: "center" }}
      >
        Something went wrong! Please try again:
        <br />
        {JSON.stringify(stateUpdate?.error)}
      </Typography>
    </>
  );

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        backgroundColor: "transparent",
      }}
    >
      <Overlay
        isVisible={stateUpdate?.isLoading}
        content={loadingContent}
        onClose={() => setLoading(false)}
      />
      <Overlay
        isVisible={stateUpdate?.isError}
        content={errorContent}
        onClose={() => setError(null)}
      />
      {!stateUpdate?.isLoading && !stateUpdate?.isError && children}
    </Box>
  );
};

export default WrapperProvider;
